export default "__VITE_ASSET__CiQ0pnRR__"